import type { CreatableOptionType } from '@/components/NeedlAutocomplete/NeedlAutocomplete';

import type { Option } from './types';

export const isCreatable = (option: Option): option is CreatableOptionType =>
  Object.keys(option).includes('title');
